
import PageContentContainer from "../../Container/PageContentContainer";
import PageHeadline from "../../PageHeadline/PageHeadline";
import ReleaseUpdateManagement from "../../ReleaseUpdates/ReleaseUpdateManagement";

export default function CreateReleaseUpdatePage() {

  return (
    <PageContentContainer>
      <PageHeadline main={"Release-Updates verwalten"} />
      <ReleaseUpdateManagement />
    </PageContentContainer>
  );
};
